"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = exports.mountLang = void 0;
const effects_1 = require("redux-saga/effects");
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const actions_1 = require("../actions");
const selectors_1 = require("./selectors");
function* mountLang(action) {
    const { data = {} } = action;
    let { lang } = data;
    if (!lang) {
        lang = yield (0, effects_1.select)(selectors_1.getLang);
    }
    yield (0, effects_1.call)(i18n_1.default.setLang, lang);
    yield (0, effects_1.put)((0, actions_1.setLang)());
}
exports.mountLang = mountLang;
function* router() {
    yield (0, effects_1.takeEvery)('SURVEY_GET_SUCCESS', mountLang);
    yield (0, effects_1.takeEvery)('SURVEY_GET_FAILURE', mountLang);
    yield (0, effects_1.takeEvery)('SURVEY_RESTORED_FROM_PRELOADED_STATE', mountLang);
    yield (0, effects_1.takeEvery)('SURVEY_LOADED_FROM_CONFIG', mountLang);
}
exports.router = router;
